module.exports = "<p>resumeexam works!</p>\n"